const Firebase = window?.['firebase']

export const auth = () => Firebase.auth()

export const providers = () => ({
    googleProvider: new Firebase.auth.GoogleAuthProvider(),
})
